export default __webpack_public_path__ + "static/media/back.c67ced52.gif";